import React, { useEffect, useRef, useState } from "react";
import web1 from "../assets/images/web1.png";
import web2 from "../assets/images/web2.png";
import web3 from "../assets/images/web3.png";
import ts from "../assets/images/ts_web.png";
import id from "../assets/images/id_web.png";
import rs from "../assets/images/rs_web.png";
import pr from "../assets/images/pr_web.png";
import {
  Box,
  Typography,
  Grid2,
  Card,
  CardMedia,
  CardContent,
  Button,
  useTheme,
  Container,
  Stack,
  Grid,
  alpha,
  Chip,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import Header from "../Components/Utils/Header";
import Hero from "../Components/Landing/Hero";
import Footer from "../Components/Utils/Footer";
import {
  Check as CheckIcon,
  Schedule as ScheduleIcon,
  Speed as SpeedIcon,
  Design as DesignIcon,
  Code as CodeIcon,
  Support as SupportIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import FAQ from "../Components/Utils/FAQ";

const testimonials = [
  {
    name: "John",
    company: "Kamak Enterprises",
    testimonial:
      "Jeremy Solutions transformed our website into a digital masterpiece. Their creativity and technical expertise are unmatched!",
  },
  {
    name: "Smith",
    company: "Mande Inc.",
    testimonial:
      "Working with Jeremy Solutions has been a game-changer. Our new website not only looks great but also performs flawlessly.",
  },
];

const PRICING_PLANS = [
  {
    title: "Blog/Portfolio",
    price: "15,000",
    features: [
      "Custom Design",
      "Mobile Responsive",
      "Contact Form",
      "Social Media Integration",
      "2-Weeks Delivery",
      "1 Month Support",
    ],
    color: "primary",
  },
  {
    title: "Informational/Static",
    price: "20,000",
    features: [
      "Custom Design",
      "Mobile Responsive",
      "Contact Form",
      "SEO Optimization",
      "2-Weeks Delivery",
      "1 Month Support",
    ],
    color: "info",
  },
  {
    title: "E-commerce",
    price: "30,000",
    features: [
      "Product Management",
      "Payment Integration",
      "Order Management",
      "Inventory System",
      "2-Weeks Delivery",
      "1 Month Support",
    ],
    color: "secondary",
    popular: true,
  },
  {
    title: "Real Estate",
    price: "40,000",
    features: [
      "Property Listings",
      "Advanced Search",
      "Virtual Tours",
      "Agent Profiles",
      "2-Weeks Delivery",
      "1 Month Support",
    ],
    color: "primary",
  },
];

const FEATURED_PROJECTS = [
  {
    title: "Mint Villas",
    description: "Luxury Real Estate Website",
    image: web1,
    url: "www.mintvillas.co.ke",
    features: [
      "Property Listings",
      "Virtual Tours",
      "Booking System",
      "Advanced Search",
    ],
  },
  {
    title: "ARM Estates",
    description: "Real Estate Management Platform",
    image: web2,
    url: "www.armestates.com",
    features: [
      "Property Management",
      "Client Portal",
      "Payment Integration",
      "Reporting System",
    ],
  },
  // Add more projects...
];

const SOCIAL_MEDIA_PLANS = [
  {
    title: "Standard Package",
    price: "15,000",
    features: [
      "1 Post Daily (Mon-Sat)",
      "3 Social Media Platforms",
      "Custom Graphics",
      "Content Calendar",
      "Performance Reports",
      "Engagement Monitoring",
    ],
    period: "month",
    color: "secondary",
  },
];

const SERVICE_ITEMS = [
  {
    title: "Tailored Solutions",
    icon: ts,
    description:
      "We take the time to understand your unique needs and tailor our solutions accordingly.",
    color: "primary",
  },
  {
    title: "Innovative Designs",
    icon: id,
    description:
      "Our team of talented designers and developers are constantly pushing the boundaries of creativity.",
    color: "secondary",
  },
  {
    title: "Responsive Support",
    icon: rs,
    description:
      "We're committed to providing you with ongoing support every step of the way.",
    color: "info",
  },
  {
    title: "Proven Results",
    icon: pr,
    description:
      "Don't just take our word for it – our track record speaks for itself. We've helped countless businesses.",
    color: "primary",
  },
];

const WEB_DESIGN_FAQS = [
  {
    question: "How long does it take to complete a website?",
    answer:
      "Our standard delivery time is 2 weeks for most projects. However, the exact timeline depends on the complexity of your website and your specific requirements. We'll provide a detailed timeline during our initial consultation.",
  },
  {
    question: "What is included in your web design packages?",
    answer:
      "Our packages include custom design, mobile responsiveness, basic SEO optimization, contact forms, social media integration, and one month of support. Additional features can be added based on your needs.",
  },
  {
    question: "Do you provide website maintenance services?",
    answer:
      "Yes, we offer ongoing maintenance packages to keep your website secure, updated, and performing optimally. This includes regular updates, backups, and technical support.",
  },
  {
    question: "Can you help with domain registration and hosting?",
    answer:
      "Yes, we can assist with domain registration and recommend reliable hosting solutions that best suit your needs. We'll handle the technical setup to ensure your website launches smoothly.",
  },
  {
    question: "Do you offer e-commerce solutions?",
    answer:
      "Yes, we specialize in creating e-commerce websites with features like secure payment gateways, inventory management, and order tracking. Our e-commerce solutions are scalable and user-friendly.",
  },
];

const WebDesign = React.forwardRef((props, ref) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const gisRef = useRef(null);
  const webRef = useRef(null);

  const handleGetStarted = () => {
    navigate("/contact");
  };

  return (
    <Box sx={{ minHeight: "100vh" }}>
      <Header active="WebDesign" />
      <Hero index={0} />

      <Box
        ref={ref || gisRef || webRef}
        sx={{ padding: "2em 0", backgroundColor: "#fff" }}
      >
        {/* Intro Section */}
        <Box sx={{ textAlign: "center", marginBottom: "3em" }}>
          <Typography variant="h3" sx={{ color: theme.palette.primary.main }}>
            Web Design
          </Typography>
          <Typography variant="h5" sx={{ color: theme.palette.secondary.main }}>
            Welcome to Jeremy Digital Services: Where Your Vision Meets Digital
            Reality!
          </Typography>
          <Typography
            variant="body1"
            sx={{
              maxWidth: "60vw",
              margin: "1.5em auto",
              color: theme.palette.text.primary,
            }}
          >
            At Jeremy Digital Services, we're more than just web designers –
            we're architects of online success. Our mission is to transform your
            digital presence into a captivating masterpiece that drives results
            and leaves a lasting impression.
          </Typography>
        </Box>

        <Container maxWidth="lg">
          <Grid container spacing={4} sx={{ mb: 8 }}>
            {SERVICE_ITEMS.map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={item.title}>
                <ServiceItem {...item} index={index} />
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* Testimonials Section */}
        <Box
          sx={{
            textAlign: "center",
            padding: "2em 0",
            backgroundColor: "#f8f8f8",
          }}
        >
          <Container>
            <Typography variant="h4" sx={{ color: theme.palette.primary.main }}>
              What Our Clients Say
            </Typography>
            <Grid2
              container
              spacing={4}
              justifyContent="center"
              sx={{ marginTop: "2em" }}
            >
              {testimonials.map((testimonial, index) => (
                <Grid2 key={index} item xs={12} md={6}>
                  <Card
                    sx={{
                      textAlign: "left",
                      borderRadius: "16px",
                      boxShadow: "0px 8px 30px #60606030",
                      p: 4,
                      height: "100%",
                    }}
                  >
                    <Typography variant="body1" sx={{ marginBottom: "1em" }}>
                      "{testimonial.testimonial}"
                    </Typography>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                      {testimonial.name}
                    </Typography>
                    <Typography variant="subtitle2" color="text.secondary">
                      {testimonial.company}
                    </Typography>
                  </Card>
                </Grid2>
              ))}
            </Grid2>
          </Container>
        </Box>

        {/* Pricing Section */}
        <Box my={8}>
          <Container py={4}>
            <Typography
              variant="h3"
              sx={{ textAlign: "center", mb: 6 }}
              data-aos="fade-up"
            >
              Our Pricing
            </Typography>
            <Grid container spacing={3} sx={{ maxWidth: "100%" }}>
              {PRICING_PLANS.map((plan, index) => (
                <Grid item xs={12} sm={6} md={3} key={plan.title}>
                  <PricingCard
                    {...plan}
                    index={index}
                    onGetStarted={handleGetStarted}
                  />
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

        {/* Featured Projects */}
        <Box my={8}>
          <Container py={4}>
            <Typography
              variant="h3"
              sx={{ textAlign: "center", mb: 6 }}
              data-aos="fade-up"
            >
              Featured Projects
            </Typography>
            <Grid container spacing={4} sx={{ maxWidth: "100%" }}>
              {FEATURED_PROJECTS.map((project, index) => (
                <Grid item xs={12} md={6} key={project.title}>
                  <ProjectCard {...project} index={index} />
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

        {/* Call-to-Action Section */}
        <Box
          sx={{
            textAlign: "center",
            padding: "4em 0",
            backgroundColor: theme.palette.primary.light,
          }}
        >
          <Typography variant="h4" sx={{ color: "#fff", marginBottom: "1em" }}>
            Ready to Elevate Your Online Presence?
          </Typography>
          <Typography
            variant="body1"
            sx={{
              maxWidth: "50vw",
              margin: "0 auto 2em auto",
              color: "#fff",
            }}
          >
            Let us transform your digital vision into reality. Contact us today
            to learn more about our web design services and how we can help your
            business thrive in the digital world.
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            sx={{ padding: "0.8em 2.5em" }}
          >
            Get Started
          </Button>
        </Box>
      </Box>

      {/* FAQ Section */}
      <FAQ
        title="Common Questions About Web Design"
        subtitle="Get answers to frequently asked questions about our web design services"
        faqs={WEB_DESIGN_FAQS}
      />

      <Footer />
    </Box>
  );
});

function ServiceItem({ title, icon, description, color = "primary", index }) {
  const theme = useTheme();
  const cardColor = theme.palette[color] ? color : "primary";

  return (
    <Card
      elevation={0}
      data-aos="fade-up"
      data-aos-delay={index * 100}
      sx={{
        height: "100%",
        p: 4,
        transition: "all 0.3s ease-in-out",
        border: `1px solid ${alpha(theme.palette[cardColor].main, 0.1)}`,
        backgroundColor: "background.paper",
        "&:hover": {
          transform: "translateY(-8px)",
          boxShadow: theme.shadows[8],
          borderColor: "transparent",
          "& .service-icon": {
            transform: "scale(1.1) rotate(5deg)",
          },
        },
      }}
    >
      <Stack spacing={3} alignItems="center">
        <Box
          className="service-icon"
          sx={{
            width: 80,
            height: 80,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 2,
            bgcolor: (theme) => alpha(theme.palette[cardColor].main, 0.1),
            transition: "transform 0.3s ease-in-out",
          }}
        >
          <Box
            component="img"
            src={icon}
            alt={title}
            sx={{
              width: 44,
              height: 44,
              objectFit: "contain",
            }}
          />
        </Box>

        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontWeight: 600,
              color: "text.primary",
              mb: 1,
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ lineHeight: 1.6 }}
          >
            {description}
          </Typography>
        </Box>
      </Stack>
    </Card>
  );
}

function PricingCard({
  title,
  price,
  features,
  color = "primary",
  popular,
  period = "once",
  index,
  onGetStarted,
}) {
  const theme = useTheme();

  const cardColor = theme.palette[color] ? color : "primary";

  return (
    <Card
      elevation={0}
      data-aos="fade-up"
      data-aos-delay={index * 100}
      sx={{
        height: "100%",
        position: "relative",
        transition: "transform 0.3s ease-in-out",
        border: `1px solid ${alpha(theme.palette[cardColor].main, 0.2)}`,
        "&:hover": {
          transform: "translateY(-8px)",
          boxShadow: theme.shadows[8],
        },
      }}
    >
      {popular && (
        <Chip
          label="Most Popular"
          color={cardColor}
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            fontWeight: 600,
          }}
        />
      )}
      <Stack spacing={3} sx={{ p: 4 }}>
        <Box>
          <Typography variant="h5" gutterBottom fontWeight={600}>
            {title}
          </Typography>
          <Stack direction="row" alignItems="flex-end" spacing={1}>
            <Typography variant="h3" fontWeight={700}>
              Ksh. {price}
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              /{period}
            </Typography>
          </Stack>
        </Box>

        <Divider />

        <List disablePadding>
          {features.map((feature) => (
            <ListItem key={feature} disablePadding sx={{ py: 1 }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <CheckIcon sx={{ color: `${cardColor}.main` }} />
              </ListItemIcon>
              <ListItemText primary={feature} />
            </ListItem>
          ))}
        </List>

        <Button
          variant="contained"
          color={cardColor}
          size="large"
          onClick={onGetStarted}
          sx={{
            mt: "auto",
            fontWeight: 600,
            "&:hover": {
              transform: "translateY(-2px)",
            },
          }}
        >
          Get Started
        </Button>
      </Stack>
    </Card>
  );
}

function ProjectCard({ title, description, image, url, features, index }) {
  const theme = useTheme();

  return (
    <Card
      elevation={0}
      data-aos="fade-up"
      data-aos-delay={index * 100}
      sx={{
        height: "100%",
        transition: "all 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-8px)",
          boxShadow: theme.shadows[8],
          "& .MuiCardMedia-root": {
            transform: "scale(1.05)",
          },
        },
      }}
    >
      <Box sx={{ position: "relative", overflow: "hidden" }}>
        <CardMedia
          component="img"
          height={240}
          image={image}
          alt={title}
          sx={{
            transition: "transform 0.3s ease-in-out",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            bgcolor: "rgba(0, 0, 0, 0.6)",
            color: "white",
            p: 2,
          }}
        >
          <Typography variant="subtitle1" component="div">
            {url}
          </Typography>
        </Box>
      </Box>

      <CardContent>
        <Stack spacing={2}>
          <Box>
            <Typography variant="h5" gutterBottom fontWeight={600}>
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          </Box>

          <Stack direction="row" flexWrap="wrap" gap={1}>
            {features.map((feature) => (
              <Chip
                key={feature}
                label={feature}
                size="small"
                sx={{
                  bgcolor: alpha(theme.palette.primary.main, 0.1),
                  color: "primary.main",
                }}
              />
            ))}
          </Stack>

          <Button
            variant="outlined"
            color="primary"
            href={`https://${url}`}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              mt: 2,
              "&:hover": {
                transform: "translateX(4px)",
              },
            }}
          >
            Visit Website
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default WebDesign;
